import React from "react";
var __jsx = React.createElement;
import ResponsivePostGrid from "@/components/shared/Grid/ResponsivePostGrid";
import InstallmentSectionSkeleton from "@/pages/homePageV2/homePageComponents/components/InstallmentSection/InstallmentSectionSkeleton";
var OilCarOffers = function OilCarOffers(_ref) {
  var _section$content;
  var section = _ref.section;
  var isLoading = false;
  var posts = (_section$content = section.content) !== null && _section$content !== void 0 ? _section$content : [];
  if (!posts.length) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full  bg-white"
  }, /*#__PURE__*/React.createElement("section", {
    className: "py-6 md:pb-8  md:max-w-[1200px] md:mx-auto"
  }, section.title && /*#__PURE__*/React.createElement("h2", {
    className: "text-lg px-4 md:text-center font-bold text-[#1B2035] mb-4 md:py-8 md:text-[30px]  "
  }, section.title), isLoading ? /*#__PURE__*/React.createElement(InstallmentSectionSkeleton, {
    numberOfCards: 4
  }) : /*#__PURE__*/React.createElement(ResponsivePostGrid, {
    posts: posts,
    sectionType: "marketing_carousel1",
    referralLocation: "oils_page"
  })));
};
export default OilCarOffers;